import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import MultipleChoiceEmbed from '../components/Exercise/MultipleChoiceEmbed';

export default Node.create({
  name: 'multipleChoice',
  group: 'block',
  atom: true,
  draggable: true,

  addAttributes() {
    return {
      mode: {
        default: 'sentences',
        parseHTML: element => element.getAttribute('data-mode') || 'sentences',
        renderHTML: attributes => attributes.mode ? { 'data-mode': attributes.mode } : {},
      },
      sentences: {
        default: [],
        parseHTML: element => {
          const data = element.getAttribute('data-sentences');
          try { return data ? JSON.parse(data) : []; } catch { return []; }
        },
        renderHTML: attributes => attributes.sentences && attributes.sentences.length
          ? { 'data-sentences': JSON.stringify(attributes.sentences) } : {},
      },
      passage: {
        default: '',
        parseHTML: element => element.getAttribute('data-passage') || '',
        renderHTML: attributes => attributes.passage ? { 'data-passage': attributes.passage } : {},
      },
      gaps: {
        default: [],
        parseHTML: element => {
          const data = element.getAttribute('data-gaps');
          try { return data ? JSON.parse(data) : []; } catch { return []; }
        },
        renderHTML: attributes => attributes.gaps && attributes.gaps.length
          ? { 'data-gaps': JSON.stringify(attributes.gaps) } : {},
      },
      title: {
        default: 'Multiple Choice Exercise',
        parseHTML: element => element.getAttribute('data-title') || 'Multiple Choice Exercise',
        renderHTML: attributes => attributes.title ? { 'data-title': attributes.title } : {},
      },
      level: {
        default: 'B1',
        parseHTML: element => element.getAttribute('data-level') || 'B1',
        renderHTML: attributes => attributes.level ? { 'data-level': attributes.level } : {},
      },
      exerciseId: {
        default: null,
        parseHTML: element => element.getAttribute('data-exercise-id') || null,
        renderHTML: attributes => attributes.exerciseId ? { 'data-exercise-id': attributes.exerciseId } : {},
      },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="multiple-choice"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'multiple-choice' })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(MultipleChoiceEmbed);
  },

  addCommands() {
    return {
      insertMultipleChoiceExercise:
        (attributes) =>
        ({ commands }) =>
          commands.insertContent({ type: this.name, attrs: attributes }),
    };
  },
});
